(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["installments"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-installments')) {
    class ProductInstallments extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('variant:change', this.updateInstallments.bind(this));
      }

      updateInstallments(event) {
        const variant = event.detail?.variant;
        if (!variant) return;

        const input = this.querySelector('input[name="id"]');
        if (input) {
          input.value = variant.id;
        }
      }
    }

    customElements.define('product-installments', ProductInstallments);
  }
  } catch(e) { console.error(e); }
})();

})();
